<footer class="footer-div">
    <!-- KYBC.Footer Top -->
    <div class="footer-top">
        <div class="row col-12">
            <div class="col-4 fondoIzquierdo"></div>

            <!-- DLG.Footer Bottom -->
            <div class="col-4">
                <a href="http://www.diputados.gob.mx">
                    <img src="/assets/images/logo.png" alt="logo" class="logo-footer centerImg img-fluid"  style="max-width: 250px;"/>
                </a>
            </div>
            <div class="col-4 fondoDerecho"></div>
        </div>
    </div>
    <!-- KYBC.Footer Bottom -->
    <div class="footer-bottom">
        <h4 class="verticalAlignCenter" style="color: white" class="p-2">
            © {{anio}} Honorable Cámara de Diputados.
        </h4>
    </div>
</footer>